import { CheckCircle2, CloudAlert } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

/** "✓ Works offline" (edge rule) / "Cloud connection required". */
export function OfflineBadge({ edge, className, compact = false }: { edge: boolean; className?: string; compact?: boolean }) {
  return edge ? (
    <Badge variant="success" className={cn('font-normal', className)} title="Every part of this condition is evaluated on the screen itself, without a connection.">
      <CheckCircle2 /> {compact ? 'Offline' : 'Works offline'}
    </Badge>
  ) : (
    <Badge variant="warning" className={cn('font-normal', className)} title="This condition uses live facts only the Cloud knows — players can’t evaluate it.">
      <CloudAlert /> {compact ? 'Cloud only' : 'Cloud connection required'}
    </Badge>
  )
}
